import API from './index';

export const modelsAPI = {
  getAll: (category) => API.get('/models', { params: { category } }),
  getAdminAll: () => API.get('/models/all'),
  getById: (id) => API.get(`/models/${id}`),
  create: (model) => API.post('/models', model),
  update: (id, model) => API.put(`/models/${id}`, model),
  delete: (id) => API.delete(`/models/${id}`)
};